import React from "react";
import cx from "classnames";
import { useSelector } from "react-redux";
import { useBreakpoints } from "@qgiv/core-react";
import { currencyString } from "@qgiv/core-js";
import {
    getCalculatedImpact,
    getFormattedMatchRatio,
    getMatchingCampaignFormattedHeading,
} from "@qgiv/donation-form";
import {
    selectHasSelectedRecurringDonation,
    selectSubtotalGift,
} from "../../../../../redux/slices/donationDetailsSlice";
import { selectActiveMatchingCampaign } from "../../../../../redux/slices/matchingCampaignsSlice";
import { selectAllFormSettings } from "../../../../../redux/slices/formSettingsSlice";

import MatchingCampaignsContent from "./MatchingCampaignsContent";

/**
 * @param {object} props
 * @param {string} props.oneTimeMatchingCampaignsTabHeading
 * @param {string} props.recurringMatchingCampaignsTabHeading
 * @param {boolean} props.shouldDisplayCountdown
 * @returns {React.ReactElement}
 */
const ConnectedMatchingCampaignsContent = ({
    oneTimeMatchingCampaignsTabHeading,
    recurringMatchingCampaignsTabHeading,
    shouldDisplayCountdown,
}) => {
    const { isMediumScreen } = useBreakpoints();
    const { currency } = useSelector(selectAllFormSettings);
    const subtotal = useSelector(selectSubtotalGift);
    const hasSelectedRecurringDonation = useSelector(
        selectHasSelectedRecurringDonation,
    );
    const {
        name = "",
        anonymousSponsorName = false,
        matchRatio = 1,
    } = useSelector(selectActiveMatchingCampaign);

    const hasSelectedAmount = subtotal > 0;

    const calculatedImpact = getCalculatedImpact({
        matchRatio,
        subtotal,
        currency,
    });

    const formattedMatch = getFormattedMatchRatio({
        currency,
        matchRatio,
        subtotal,
    });
    const formattedSubtotal = currencyString(subtotal, currency);

    const formattedHeading = getMatchingCampaignFormattedHeading({
        anonymousSponsorName,
        hasSelectedRecurringDonation,
        name,
        oneTimeMatchingCampaignsTabHeading,
        recurringMatchingCampaignsTabHeading,
    });

    const matchingCampaignsContentProps = {
        calculatedImpact,
        formattedHeading,
        formattedMatch,
        hasSelectedAmount,
        isMediumScreen,
        formattedSubtotal,
    };

    return (
        <div
            className={cx(
                "col",
                "col--12",
                "-padding--0",
                shouldDisplayCountdown && "-padding-top--20",
            )}
        >
            <MatchingCampaignsContent {...matchingCampaignsContentProps} />
        </div>
    );
};

export default ConnectedMatchingCampaignsContent;
